import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { getConsent } from "@/components/CookieConsent";

const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const GTM_ID = "GTM-N8T2X4DF";

let injected = false;

function injectScripts() {
  if (injected || typeof window === "undefined" || getConsent() !== "granted") return;
  injected = true;

  // Google Tag Manager (loaded only after cookie consent)
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  const g = document.createElement("script");
  g.async = true;
  g.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(g);

  // Google Analytics 4
  if (GA4_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID, { send_page_view: false });
  }

  // Meta Pixel (Facebook)
  if (META_PIXEL_ID) {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,"script","https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", META_PIXEL_ID);
  }
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || getConsent() !== "granted") return;
  {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
  }
  if (GA4_ID && window.gtag) window.gtag("event", name, params);
  if (META_PIXEL_ID && window.fbq) window.fbq("trackCustom", name, params);
}

export function trackConversion(name, value_chf = 0) {
  if (typeof window === "undefined" || getConsent() !== "granted") return;
  {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, conversion_name: name, value: value_chf, currency: "CHF" });
  }
  if (GA4_ID && window.gtag) window.gtag("event", "conversion", { name, value: value_chf, currency: "CHF" });
  if (META_PIXEL_ID && window.fbq) {
    const std = { register: "CompleteRegistration", subscribe: "Subscribe", lead: "Lead", start_trial: "StartTrial" }[name];
    if (std) window.fbq("track", std, { value: value_chf, currency: "CHF" });
    else window.fbq("trackCustom", name, { value: value_chf, currency: "CHF" });
  }
}

/**
 * Mount once at App root. Auto-tracks pageviews on every route change.
 * Configure via /app/frontend/.env :
 *   REACT_APP_META_PIXEL_ID=123456789012345
 *   REACT_APP_GA4_MEASUREMENT_ID=G-XXXXXXXXXX
 * If both empty → no-op.
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    injectScripts();
    window.addEventListener("oresto-consent", injectScripts);
    return () => window.removeEventListener("oresto-consent", injectScripts);
  }, []);

  useEffect(() => {
    const path = location.pathname + location.search;
    // GTM: push virtual pageview so GA4/Meta tags inside GTM can fire
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "page_view", page_path: path, page_location: window.location.href });
    }
    if (GA4_ID && window.gtag) window.gtag("event", "page_view", { page_location: window.location.href, page_path: path });
    if (META_PIXEL_ID && window.fbq) window.fbq("track", "PageView");
  }, [location]);

  return null;
}
